var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SimpleTextPopup", {
    attrs: { title: _vm.title, hideRgtBtn: true, medium: "" },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return _vm._l(_vm.messages, function(messageItem) {
            return _c(
              "v-layout",
              {
                key: messageItem.time,
                attrs: {
                  row: "",
                  "align-baseline": "",
                  wrap: "",
                  "justify-start": ""
                }
              },
              [
                _c(
                  "v-flex",
                  { staticClass: "text-xs-right", attrs: { xs3: "" } },
                  [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.toDateYYYYMMDDHHmm(new Date(messageItem.time))
                        )
                      )
                    ]),
                    _vm._v(":\n        ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  {
                    staticClass: "text-xs-left",
                    attrs: { xs9: "", "pl-1": "" }
                  },
                  [
                    _vm._v(
                      "\n           " +
                        _vm._s(messageItem.message) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            )
          })
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cd9ab98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd9ab98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelErrorPopup.vue
// module id = null
// module chunks = 